import '@workspace/ui/globals.css'
import './index.css'

import * as Sentry from '@sentry/react'
import { initGtag } from './lib/gtag'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_APP_ENV || 'local',
  })
}

initGtag()

// Setup error handlers
import './lib/logger'

import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { client } from '@workspace/api-backend/client'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { queryClient } from './lib/query-client'
import { router } from './router'

client.setConfig({
  baseUrl: import.meta.env.VITE_BACKEND_URL,
  credentials: 'include',
})

const rootElement = document.getElementById('root')

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        {/* <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" /> */}
      </QueryClientProvider>
    </StrictMode>
  )
}
